export function isOverflowingLeft(
  element: HTMLElement,
  parentElement: HTMLElement | null
): boolean {
  if (!parentElement) {
    return false;
  }

  const offsetLeft = element.offsetLeft;
  const scrollLeft = parentElement.scrollLeft;

  const positionInVisibleArea = offsetLeft - scrollLeft;
  return positionInVisibleArea < 0;
}
